//////////////////////////////////////////////////////
///////// PROD
/////////////////////////////////////////////////////

export const POOL_DATA = {
  UserPoolId: 'us-east-1_Pon8oHbTl',
  ClientId: 'gb4cdh0ed2l2tt2k1kd28fftg',
};

export const AWS_CONFIG_REGION = 'us-east-1';
export const IDENTITY_POOL_ID = 'us-east-1:a73e6d80-7746-48c2-8429-9546048d210c';

//WEB Only API
export const TRANSACTIONS_URL = 'https://naanac.net:8443/api/profile/transactions';

//Shared API
export const FEEDBACK_URL = 'https://naanac.net:8443/api/profile/saveFeedback';
export const USERNAME_URL = 'https://naanac.net:8443/api/profile/getusername';

export const SHOPBYSTORE_URL = 'https://naanac.net:8443/api/store/shopbystore';
export const GETSTOREFILTER_URL = 'https://naanac.net:8443/api/store/getStoreFilter';

//////////////////////////////////////////////////////
///////// DEV
/////////////////////////////////////////////////////
//export const POOL_DATA = {
//    UserPoolId: 'us-east-1_qQe8EzpAB',
//     ClientId: '59vq8os0gahsdjea2b494pa0ia',
// };
//
// export const AWS_CONFIG_REGION = 'us-east-1';
// export const IDENTITY_POOL_ID = 'us-east-1:38ac7224-65c7-4844-8d30-63c2b2d33464';
//
// export const TRANSACTIONS_URL = 'https://916beka91h.execute-api.us-east-2.amazonaws.com/Prod/gettransactionhistory';
// export const FEEDBACK_URL = 'https://916beka91h.execute-api.us-east-2.amazonaws.com/Prod/putfeedback';
// export const USERNAME_URL = 'https://916beka91h.execute-api.us-east-2.amazonaws.com/Prod/getusername';




// WEBPACK FOOTER //
// ./src/utils/config.js